// We'll initially only support mp4 to aim for the best browser support.
export const VIDEO_EXTENSIONS = ['.mp4'] as const

// Supported image extensions
export const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg'] as const
